import BaseModel from '../base/BaseModel.model';
export default class ExpectedResult extends BaseModel {
   public  name?: string;
   public jobAssumptions?: string;
   public meansOfVerification?: string;
    init(){
     this.name =  "";
     this.jobAssumptions = "";
     this.meansOfVerification = "";
    }

}